﻿export const start = {
    text: 'Du behöver bara svara på några frågor så sköter vi resten.',
    headline: 'Börja spara idag',
    buttonText: 'Börja spara'
}

export const preSign = {
    text: 'När du har skickat in din ansökan kommer den att kontrolleras automatiskt. Om allt ser rätt ut kan du i nästa steg signera din ansökan med BankID och starta ditt sparande.',
    headline: 'Nu kan du skicka in din ansökan!',
    paragraph2: 'Du kommer även få ett e-postmeddelande från Futur Pension med en länk för att signera din ansökan. Om du signerar i nästa steg kan du bortse från det meddelandet. ',
    paragraph3: 'Din ansökan med de svar du lämnat finns tillgänglig under Mina dokument på Lärarförsäkringars Mina sidor.',
    buttonText: 'Skicka in'
}

export const account = {
    text: 'Du betalar ditt sparande med autogiro. Ange kontonumret till det konto som du vill att pengarna ska dras ifrån varje månad.',
    headline: 'Betala med autogiro',
    labelClearing: 'Clearingnummer',
    labelAccount: 'Kontonummer',
}

export const manualValidation = {
    text: 'Din ansökan är mottagen men behöver behandlas manuellt. Du kommer att bli kontaktad med mer information inom kort. Tack för din ansökan!',
    headline: 'Din ansökan måste behandlas manuellt',
    buttonText: 'Okej, avsluta'
}

export const error = {
    text: 'Din ansökan kunde tyvärr inte skickas in. Kontakta kundservice för att få hjälp.',
    headline: 'Något har gått fel',
    buttonText: 'Okej, avsluta'
}

export const stopDialog = {
    text: 'Du behöver prata med en av våra rådgivare. Tryck på knappen för att avsluta guiden och komma till bokningssidan.',
    headline: 'Prata med rådgivare',
    buttonText: 'Ok, avsluta och boka rådgivning',
    linkText: 'Avbryt'
}

export const closeDialog = {
    text: 'Vill du avsluta? Dina svar sparas inte.',
    headline: 'Avsluta',
    buttonText: 'Okej, jag vill avsluta',
    linkText: 'Avbryt'
}

export const hero = {
    headline: 'Starta ditt sparande',
    text: 'Börja spara i en kapitalförsäkring med fonder. Ett enkelt och förmånligt sparande för medlemmar i Sveriges Lärare och Sveriges Skolledare med Futur Pension som försäkringsgivare.'
}

export const buttonText = {
    next: 'Nästa',
    leave: 'Okej, jag vill avsluta',
    advisor: 'Ok, avsluta och boka rådgivning',
    quit: 'Okej, avsluta',
    start: 'Börja spara'
}

export const redirects = {
    start: 'https://www.lararforsakringar.se/',
    advise: 'https://www.lararforsakringar.se/pension--sparande/boka-radgivning/'
}
